import useAPIService from '../common/useApiService';

export const useUpdateItemComment = (id, data) => {
  const [updateItemComment, invokeUpdateItemComment] = useAPIService(`item-comments/${id}`, { method: 'put', data });

  return [
    updateItemComment,
    invokeUpdateItemComment,
  ];
}